import { get, includes } from 'lodash-es'
import { createContext, useContext, useMemo, useState } from 'react'

const HousePropertyValueContext = createContext()
export default HousePropertyValueContext

export function useHousePropertyValueContext() {
  return useContext(HousePropertyValueContext)
}

export const TABS = {
  estimate: { label: 'OneRoof  estimate', value: 1, event: 'oneroof property estimate' },
  rv: { label: 'Rating valuation', value: 2, event: 'rating valuation' },
  overTime: { label: 'Estimate over time', value: 3, event: 'estimate over time' },
  history: { label: 'Property history', value: 4, event: 'property history' },
}
export function useHousePropertyValueState(data, overTime, histories) {

  const tabs = useMemo(() => {
    let res = [TABS.estimate]
    if (
      get(data, 'publicRecords.rateableValue')
      && get(data, 'publicRecords.landValue')
      && get(data, 'publicRecords.improvementValue')
    ) {
      res.push(TABS.rv)
    }
    if (overTime) {
      res.push(TABS.overTime)
    }
    if (histories) {
      res.push(TABS.history)
    }
    return res
  }, [overTime, histories, data])
  const [tab, setTab] = useState(includes(tabs, TABS.rv) && !data.avm ? TABS.rv : TABS.estimate)

  return {
    tab,
    tabs,
    setTab
  }
}